module.exports = __webpack_public_path__ + "static/errolsonworkshop-1a219af115fadf799b5dd935cfc718fa.jpg";